import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export function GoogleCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);
  useEffect(() => {
    if (done.current) { return; }
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    const remember = localStorage.getItem("dpdp.remember") === "1";
    localStorage.removeItem("dpdp.remember");
    api.post("/auth/google", { session_id: sessionId, remember })
      .then(({ data }) => {
        if (data.signup_required) { setUser(false); nav("/register", { replace: true, state: { google: data, remember } }); }
        else if (data.mfa_required) { setUser(false); nav("/login", { replace: true, state: { mfa: data } }); }
        else { setUser(data); nav("/", { replace: true }); }
      })
      .catch((e) => { setUser(false); toast.error(errMsg(e)); nav("/login", { replace: true }); });
  }, [location.hash, nav, setUser]);
  return <div className="grid h-screen place-items-center bg-[#f6f8fb] text-sm text-slate-500" data-testid="google-callback">Signing you in securely…</div>;
}
